export default __webpack_public_path__ + "static/media/add_position.90b4bc60.svg";